module.exports = __webpack_public_path__ + "img/hakone-soba-logo.5e627fe9.png";